import { useRouting } from '@tbitop/routing';
import { isEmpty, isUndefined } from 'lodash-es';

export function useModalQueryParam(paramName: string, expectedParamValue?: string) {
  const { query, pushWithoutQueryParams } = useRouting();
  const value = query[paramName];
  const isOpen = isUndefined(expectedParamValue) ? !isEmpty(value) : (expectedParamValue === value);
  const handleClose = () => pushWithoutQueryParams([paramName], { scroll: false });

  return {
    value,
    isOpen,
    handleClose,
  };
}
